export enum DelegationType {
	DELEGATE_TASK = 'DELEGATE_TASK',
	RE_ASSIGN_TASK = 'RE_ASSIGN_TASK',
}
